import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=06836123&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06836123",
  null
  
)

export default component.exports